export default __webpack_public_path__ + "static/media/4.a9239fb5.jpg";